let Tourney;
if (gon.tournament) {
  let tourney = gon.tournament;
  let tid = tourney.tid;
  let name = tourney.name;

  let njpLocal = tourney.tid.match(/njp-local|njp-doubles/);

  Tourney = {
    milp: tourney.milp,
    njp: (!!tid.match(/^njp/) || njpLocal || tourney.id === 13),// && tid !== "champs-moneyball-10-25",
    njpMoneyball: name.match(/Moneyball/),
    agape: !!name.match(/Agape/),
    excelSimple: !!tid.match(/dink-pink|dink-cure|guns-vs-hoses-12-24|save-tata/),
    dinkEvents: !!tid.match(/dink-pink|dink-cure|accss-11-24|save-tata/),
    mlp: tourney.club_id === 21,
    excel: tourney.club_id === 1,
    swamp: tourney.club_id === 19,
    hopl: tid.match(/^hop/),
    hopa: tid.match(/hop-10-25|hop-1-26/),
    joolaTest: tid === "joola-test-7-25",
    joola: tid.match(/^joola/),
    stjude: tid.match(/stjude/),
    ua4v4: tid.match(/^4v4-under-armour/),
    ld4p: tourney.tid === "legacy-d4p-10-24",
    seattleKids: tourney.tid === "seattle-kids-11-24",
    guns: tourney.tid === "guns-vs-hoses-12-24",
    socalFinals: tourney.tid === "socal-royal-finals-12-24",
    lvmpd: tourney.tid.match(/^lvmpd/),
    skagit: tourney.tid === "skagit-8-25",
    hop_tryouts: tourney.tid.match(/hop-tryouts-armory/),
    commissioner: !!name.match(/Commissioners/),
    njpLocal,
    demo: !!name.match(/Demo/),
    lehyc: !!name.match(/LEHYC/),
    simple: tourney.tid === "vpt-10-24",
    asf24: tourney.tid === "all-state-fall-24",
    allstateLeague: !!name.match(/All State League/),
    dropball: tourney.tid === "drop-the-ball-1-26",
    shootout: tourney.tid === "shootout-4-26",
    done: tourney.status === "done",
    reg: tourney.status === "reg_opened",
    no_rating: tourney.rating === "no",
    dupr: tourney.rating === "dupr",
    no_reg: tourney.reg_status === "no",
    no_pay: tourney.reg_status === "no" || !(tourney.player_price || tourney.price),
    hidePlayers: tourney.tid === "seattle-kids-11-24" && !gon.user,
    sublist: gon.sublist || [],
    withSubs: !!gon.with_subs,
  }

  Tourney.jOnly = Tourney.njp || Tourney.seattleKids;
}
else
  Tourney = {
  }

export default Tourney;